module.exports = __webpack_public_path__ + "static/Roboto-Italic.4357beb8.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/data/fonts/Roboto-Italic.woff2
// module id = 311
// module chunks = 79611799117203